var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box"},[(_vm.title)?_c('div',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default"),(_vm.showGap)?_c('div',{staticClass:"card-gap"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }